export class FormatDateUtils {
  static formatDate(date: Date | string | undefined, locale: string = 'en-US', includeTime: boolean = false): string {
    if (!date) return '';
    const dateObj = new Date(date);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = dateObj.toLocaleString(locale, { month: 'short' }).toUpperCase().replace('.', '');
    const year = dateObj.getFullYear();

    return `${day}-${month}-${year}`;
  }
}
